<template>
<div id="map-wrapper">
   <div id="map">
      <region-select-form
         :language-is-english="languageIsEnglish"
      />
      <div class="added-ol-control-wrapper">
         <div
            class="ol-unselectable ol-control added zoom-to-location"
            >
            <button @click="showLocationForm = !showLocationForm">
               <img src="../../assets/icons/zoom-to-loc.svg">
            </button>
            <zoom-to-loc-form
               v-if="showLocationForm"
               v-on:zoom-to-location="zoomToLocation"
            />
         </div>
         <div class="ol-unselectable ol-control added printer-icon">
            <button @click="emitShowPrintModal"><img src="../../assets/icons/printer-icon.svg"></button>
         </div>
      </div>
      <div class="base-layer-select-wrapper">
         <div
            class="base-layer-select-toggler" style="color: white;">
            <img src="../../assets/icons/base-layer-icon.svg" alt="base layer toogler">
            <br/>{{this.languageIsEnglish ? 'Base Maps' : 'आधार नक्सा'}}
         </div>
         <div class="base-layer-select">
            <ul>
               <li @click="hideAllBaseLayers"><img src="@/assets/icons/none.png"><br>None</li>
               <li @click="showOSM"><img src="@/assets/icons/screenshot.png"><br>OSM</li>
               <li @click="showBing"><img src="@/assets/icons/bing.png"><br>Satellite</li>
            </ul>
         </div>
      </div>
      <div class='legend-wrapper'>
         <div id="hovered-choropleth-value" v-if="choroplethLabel">
            <div class='header'>{{ languageIsEnglish ? choroplethLabelTitle.english : choroplethLabelTitle.nepali }}</div>
            <span class="label">{{ choroplethLabel }}</span>
         </div>
         <!-- <legend-box
            :languageIsEnglish="languageIsEnglish"
         /> -->
      </div>
   </div>
</div>
</template>

<script>
import ZoomToLocForm from './ZoomToLocForm';
import RegionSelectForm from './RegionSelectForm';
// import LegendBox from './LegendBox';
import { animateToPoint } from '../../js/mapHelpers';
import { baseLayers } from '../../js/layers/base';
import { bus } from '../../main';


export default {
   props: {
      languageIsEnglish: { type: Boolean, required: true },
      choroplethLabel: { type: String, required: true },
   },
   components: {
      'zoom-to-loc-form': ZoomToLocForm,
      'region-select-form': RegionSelectForm,
      // 'legend-box': LegendBox,
   },
   data()
   {
      return {
         choroplethLabelTitle: { english: 'Overall AFR, 2011', nepali: 'कुल किशोरी प्रजनन्  दर, २०११' },
         showLocationForm: false,
         selectedFertilityLayer: null,
         selectedPopulationLayer: null,
         showLegends: true,
      }
   },
   created()
   {
      bus.$on('label-title-change', (labelObject) =>
      {
         this.choroplethLabelTitle = labelObject;
      });
   },
   methods: {
      zoomToLocation(location)
      {
         animateToPoint(location);
      },
      hideAllBaseLayers()
      {
         Object.values(baseLayers).forEach(layer=>layer.setVisible(false));
      },
      showOSM()
      {
         this.hideAllBaseLayers();
         baseLayers.osm.setVisible(true);
      },
      showBing()
      {
         this.hideAllBaseLayers();
         baseLayers.bing.setVisible(true);
      },
      emitShowPrintModal()
      {
         bus.$emit("show-print-map-modal");
      }
   }
}
</script>

<style lang="scss" scoped>
@import '~ol/ol.css';
#map-wrapper {
   flex: 7 0 500px;
   height: 100%;
   padding: 0.4em;
}

#map {
   position: relative;
   background: #e5e5e5;
   width: 100%;
   height: 100%;
   border-radius: 2px;
   overflow: hidden;
   box-shadow: 0 0 3px grey;
   border: solid 1px white;
}

.dashboard {
   background: none !important;
   font-weight: 500;
   top: 0.3em;
   left: 0.3em;
   width: auto;
   transition: 0.1s ease;
   padding-right: 5px;
   display: flex;
   align-items: center;
   z-index: 2;
   
   button {
      box-shadow: -4px 4px 4px 2px rgba(0, 0, 0, 0.2);
      outline: none;
      border-radius: 50%;
      border: solid 2px rgb(255, 255, 255);
      transition: inherit;
      width: auto !important;
      height: auto !important;
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
   }

   &:hover button {
      transform: translateY(-2px);
      box-shadow: -8px 8px 6px rgba(0, 0, 0, 0.2);
   }

   span {
      color: white;
      display: inline-block;
      font-size: 12px;
      font-weight: 600px;
      transition: inherit;
      margin-left: 0.8em;
      text-shadow: 0px 0px 1em rgba(0, 0, 0, 0.8);
   }

   &:hover span {
      transform: scale(1.05);
      margin-left: 0.4em;
      font-size: 14px;
      text-shadow: -4px 4px 1em rgba(0, 0, 0, 0.9);
   }
}

.added-ol-control-wrapper {
   left: 0.5em;
   top: 6.3em;
   position: absolute;
   display: flex;
   align-items: flex-start;
   flex-direction: column;
   z-index: 2;
}

.added-ol-control-wrapper .added.ol-control {
   position: static !important;
   margin: 0.5px 0;
}

.zoom-to-location {
   top: 11em;
   z-index: 3;
}

.base-layer-select-wrapper {
   position: absolute;
   z-index: 2;
   right: 0em;
   top: 0em;
   display: flex;
   align-items: center;
   color: white;
   overflow: hidden;
   cursor: pointer;
}

.base-layer-select-toggler {
   font-size: 14px;
   padding: 5px;
   background-image: linear-gradient(to right, #276868cc, #2e7c7cde);
   text-align: center;
   z-index: 3;
   border-radius: 0px;
   width: 4em;
   order: 1;
}

.base-layer-select-toggler:hover + .base-layer-select,
.base-layer-select:hover {
   opacity: 1;
   pointer-events: auto;
   transform: translateX(0);
   width: auto;
   height: auto;
}

.base-layer-select {
   background: #c5c5c5ab;
   border-radius: 2px;
   order: 0;
   width: 0;
   height: 0;
   transition: all 0.4s ease-in-out;
   opacity: 0;
   pointer-events: none;
   transform: translateX(100%);
   overflow: hidden;
   
   ul {
      text-align: center;
      padding: 0;
      margin: 0;
   }

   li {
      display: inline-block;
      padding: 4px 10px;
      font-size: 14px;
      cursor: pointer;

      img {
         width: 70px;
         height: 30px;
      }
   }
}

.legend-wrapper {
   z-index: 3;
   position: absolute;
   left: 0.5em;
   bottom: 0.5em;

   #hovered-choropleth-value {
      // position: absolute;
      // bottom: 3em;
      // right: 0.5em;
      // z-index: 3;
      background:rgba(255, 255, 255, 0.747);
      border-radius: 3px;
      padding: 4px 8px;
      box-shadow: -5px 5px 10px rgba(0,0,0,0.2);
      margin-bottom: 2px;
      
      .header {
         font-size: 14px;
      }
   
      .label {
         font-size: 12px;
      }
   }
}
</style>
